import { mediaQuery } from 'constants/ui';

export const SAVING_OVERLAY_OPACITY = 0.6;

export const contentOuterWrapperStyles = {
  position: 'relative',
  height: '100%',
  width: '100%',
  overflow: 'hidden',
};

export const contentWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  padding: '24px',
  height: '100%',
  overflow: 'auto',
};

export const contentHeaderStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '16px',
};

export const pickerSectionStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
};

export const conditionCardStyles = {
  display: 'flex',
  flexDirection: 'column',
  borderRadius: '8px',
  border: ({ palette }) => `1px solid ${palette.divider}`,
  backgroundColor: ({ palette }) => palette.background.paper,
};

export const conditionCardHeaderStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '16px',
  padding: '16px 24px',
  borderBottom: ({ palette }) => `1px solid ${palette.divider}`,
};

export const conditionCardHeaderTitleStyles = {
  flex: 1,
  minWidth: 0,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export const conditionCardHeaderActionsStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
};

export const conditionCardBodyStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  padding: '24px',
};

export const conditionCardFieldsRowStyles = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
  gap: '24px',
  alignItems: 'flex-start',

  [mediaQuery.mobile]: {
    gridTemplateColumns: '1fr',
  },
};

export const taskGridStyles = {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  gap: '24px',

  [mediaQuery.mobile]: {
    gridTemplateColumns: '1fr',
  },
};

export const taskCardStyles = {
  display: 'flex',
  flexDirection: 'column',
  borderRadius: '8px',
  border: ({ palette }) => `1px solid ${palette.divider}`,
  backgroundColor: ({ palette }) => palette.background.paper,
};

export const taskCardHeaderStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '8px',
  padding: '12px 16px',
  borderBottom: ({ palette }) => `1px solid ${palette.divider}`,
};

export const taskCardBodyStyles = {
  display: 'flex',
  flexDirection: 'column',
  padding: '16px',
  position: 'relative',
};

export const taskInfoButtonWrapperStyles = {
  position: 'absolute',
  top: '18px',
  left: '86px',
  zIndex: 1,
  display: 'flex',
  alignItems: 'center',
};

export const taskInfoIconWrapperStyles = {
  display: 'inline-flex',
  color: ({ palette }) => palette.text.secondary,
};

export const taskInfoTooltipSlotProps = {
  tooltip: {
    sx: {
      maxWidth: 320,
      whiteSpace: 'nowrap',
    },
  },
};

export const emptyStateStyles = {
  padding: '24px',
  textAlign: 'center',
  color: ({ palette }) => palette.text.secondary,
};

export const pickerFiltersRowStyles = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
  gap: '16px',
};
